import type { ReactNode } from "react";

export function Banner({ tone = "info", children, live }: { tone?: "info" | "warn" | "error" | "ok"; children: ReactNode; live?: boolean }) {
  return (
    <div className={`banner banner--${tone}`} role={tone === "error" ? "alert" : live ? "status" : undefined} aria-live={live ? "polite" : undefined}>
      {children}
    </div>
  );
}
